import * as React from 'react';

import { Form } from '@longline/aqua-ui/containers/Form';
import { Input } from '@longline/aqua-ui/inputs/Input';

import { ISpecies } from '../../api/models/ISpecies';
import { Grid } from '../../ui/Grid';

interface IProps {
  species: ISpecies;
  onChange: (data: ISpecies, forceUpdate: boolean) => void;
  onValidate: (valid: boolean) => void;
  dirty?: boolean;
}

const SpeciesForm = (props: IProps) => {
  return (
    <Form data={props.species} dirty={props.dirty} onChange={props.onChange} onValidate={props.onValidate}>

      <Grid>
        <Grid.Item weight={6}>
          <Form.Field 
            rules={{
              required: { message: "Name is required." },
              maxLength: { length: 255 },
            }}
            name="name" 
            value={props.species.name}
            label="Name"
            wrapper='box'
            hint="Species core name"
            control={(<Input transparent type="text" placeholder="Name" fluid/>)}
          />
        </Grid.Item>

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="genus" 
            value={props.species.genus}
            label="Genus"
            wrapper='box'
            control={(<Input transparent type="text" placeholder="Genus" fluid/>)}
            hint="Genus name"
          />
        </Grid.Item>

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="species" 
            value={props.species.species}
            label="species"
            wrapper='box'
            control={(<Input transparent type="text" placeholder="Species" fluid/>)}
            hint="Species name"
          />
        </Grid.Item>

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameUK" 
            value={props.species.nameUK}
            label="UK English"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="UK English" fluid/>)}
          />
        </Grid.Item>

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameUS" 
            value={props.species.nameUS}
            label="US English"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="US English" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameNO" 
            value={props.species.nameNO}
            label="Norwegian"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="Norwegian" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameFR" 
            value={props.species.nameFR}
            label="French"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="French" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameES" 
            value={props.species.nameES}
            label="Spanish"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="Spanish" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameIT" 
            value={props.species.nameIT}
            label="Italian"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="Italian" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="namePT" 
            value={props.species.namePT}
            label="Portuguese"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="Portuguese" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              maxLength: { length: 255 },
            }}
            name="nameZH" 
            value={props.species.nameZH}
            label="Chinese"
            wrapper='box'
            hint="Translation"
            control={(<Input transparent type="text" placeholder="Chinese" fluid/>)}
          />
        </Grid.Item>        

        <Grid.Item weight={3}>
          <Form.Field 
            rules={{
              isInt: { message: "Must be integer."},
              min: { value: 0, message: "Must be positive."}
            }}
            name="modelCode" 
            value={props.species.modelCode}
            label="Model code"
            wrapper='box'
            hint="ORGANX model code"
            control={(<Input transparent type="text" placeholder="Code" fluid/>)}
          />
        </Grid.Item>           

        <Grid.Item weight={3}>
          <Form.Field
            rules={{
              isFloat: { message: "Must be a number."},
              min: { value: 0, message: "Must be positive."}
            }}
            name="initialWeight"
            value={props.species.initialWeight}
            label="Initial weight"
            wrapper='box'
            hint="Starting weight for a culture run (g)"
            control={(<Input transparent type="text" placeholder="g" fluid/>)}
          />
        </Grid.Item>

        <Grid.Item weight={3}>
          <Form.Field
            rules={{
              isInt: { message: "Must be integer."},
              min: { value: 1, message: "Must be positive."}
            }}
            name="culturePeriod"
            value={props.species.culturePeriod}
            label="Culture period"
            wrapper='box'
            hint="Typical culture period (days)"
            control={(<Input transparent type="text" placeholder="days" fluid/>)}
          />
        </Grid.Item>

        <Grid.Item weight={3}>
          <Form.Field
            rules={{
              isFloat: { message: "Must be a number."},
              min: { value: 0, message: "Must be positive."}
            }}
            name="harvestWeight"
            value={props.species.harvestWeight}
            label="Harvest weight"
            wrapper='box'
            hint="Expected weight after the culture period (g)"
            control={(<Input transparent type="text" placeholder="g" fluid/>)}
          />
        </Grid.Item>


      </Grid>
      
        
    </Form>    
  )
}

export { SpeciesForm }
